import api from '@/api';
import { API_BASE_URL } from '../../index';
import { QuestReportDirectSaleXFinancialRequest } from '../../Reports/DirectSaleXFinancial/DirectSaleXFinancial.types';

const CONTROLLER_URL = `${API_BASE_URL}/Csv`;

export async function getQuestReportDirectSaleXFinancial(
  params: QuestReportDirectSaleXFinancialRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/VdXFinancial`,
    params,
  )) as unknown;

  return result as BlobPart;
}
